import { VaccinationCategory } from '../job';
import { GenericValueLabelType } from './shared';

export type AdminType = {
    label: string;
    value: string;
    enabled: boolean;
    colour: string;
};

export type AdminTypeV2 = GenericValueLabelType & {
    enabled: boolean;
    color: string;
    syncToS1?: boolean;
};

export type AvailabilityTimeSetting = {
    label: string;
    value: string;
    enabled: boolean;
    startTime: string;
    endTime: string;
};

export type Band = {
    label: string;
    value: string;
};

export type BlockPrice = {
    label: string;
    value: string;
};

export type BlockUnit = {
    label: string;
    value: string;
};

export type Disposition = {
    label: string;
    value: string;
    timeInMins: number;
};

export type Features = {
    [key: string]: boolean;
};

export type HCPType = {
    label: string;
    value: string;
    enabled: boolean;
};

export type Hub = {
    id: string;
    name: string;
    telephone: string;
    address: string;
    compatibleWith?: string[];
};

export type LegendOption = {
    label: string;
    colour: string;
};

export type LegendOptionV2 = {
    label: string;
    color: string;
};

export type LegendV2 = {
    [key: string]: LegendOptionV2[];
};

export type LiveLocationThreshold = {
    color?: {
        above: string;
        below: string;
    };
    gracePeriodMinutes?: number;
    value?: number;
};

export type ManagementDay = {
    label: string;
    value: string;
    isArchived: boolean;
};

export type Service = GenericValueLabelType & {
    color: string;
    enabled: boolean;
    syncToS1?: boolean;
};

export type Pathway = GenericValueLabelType & {
    enabled: boolean;
    services: Service[];
};

export type AbortReason = {
    appliesToIndividualJobAssignment: boolean;
    label: string;
    enabled: boolean;
    notesRequired: boolean;
    s1CancellationReason: string;
};

export type VaccinationDetails = {
    [key in VaccinationCategory]?: {
        requiresPickup: boolean;
    };
};

export enum LogLevel {
    TRACE = 'trace',
    DEBUG = 'debug',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error',
    FATAL = 'fatal',
}

export type Config = {
    abortReasons: AbortReason[];
    address: string;
    adminTypes?: AdminTypeV2[];
    disposition?: Disposition[];
    allowReducedPinEntry?: boolean;
    availabilityTimeSettings?: AvailabilityTimeSetting[];
    bands?: Band[];
    blockSize?: {
        hours: {
            prices: BlockPrice[];
            units: BlockUnit[];
        };
    };
    customShiftTypes?: string[];
    doseInterval?: {
        [key: string]: {
            [key: string]: string;
        };
    };
    emergencyContactNumber?: string;
    features: Features;
    hcpTypes?: HCPType[];
    hubs?: Hub[];
    legendOptions?: LegendOption[];
    legendV2?: LegendV2;
    liveLocationThreshold?: LiveLocationThreshold;
    logLevel?: LogLevel;
    managementDay?: ManagementDay[];
    mapCentre?: {
        lat?: number;
        lng?: number;
    };
    maxStackedJobs?: number;
    name: string;
    odsCode?: string;
    onboardingId: string;
    optionsAdminType?: {
        [key: string]: AdminType;
    };
    org: string;
    pathwaysV2?: Pathway[];
    patientUploadAdapter?: string;
    permittedDomains?: string[];
    referredBy?: string[];
    referrer?: string[];
    s1UnitName?: string;
    smsSenderName?: string;
    telephone: string;
    vaccinationDetails?: VaccinationDetails;
    vaccinationDuration?: {
        [key: string]: string;
    };
};
